<template >
    <div>
        <section-definition v-if="insert_form == false" :extraOptions="options" :title="page.title" :icon="page.icon"
        @addNew="NewContact"  @openFilter="isFilter" :addNewData="page.addnew" @refreshPage="refreshThisPage" @plusPage="addcontact"></section-definition>
        <div v-if="insert_form == false" class="main_view_ticket">


            <div class="ticket_body_view">
                <v-data-table :headers="headers" :items="ContactData" class="elevation-1" hide-default-header
                    :headers-length="10" hide-actions>
                    <template v-slot:headers="props" id="table-scroll">
                        <tr style="height: 30px">

                            <th style="min-width: 150px;text-align: center;" v-for="head in props.headers"
                                :key="head.name">
                                <div>{{ head.text }}</div>
                            </th>
                            <th style="text-align: center">Action</th>
                        </tr>
                    </template>
                    <template v-slot:items="props">

                        <td style="min-width: 170px;text-align: center;" class="checkEmpty"
                            v-for="(property, index) in Object.keys(props.item)" :key="index">
                            <div>
                                <p style="margin-top: 14px" v-if="property !== 'action'">
                                    {{
                                        props.item[property] == "" ||
                                            props.item[property] == null ||
                                            props.item[property] == undefined
                                            ? "N/A"
                                            : props.item[property]
                                    }}
                                </p>
                                <div class="icon_section">
                                    <template v-if="property == 'action'">
                                        <v-icon v-show="page.canedit" small class="mr-4"
                                            @click="contact_info(props.item)">info</v-icon>

                                        <v-icon color="red" @click="deletepopup(props.index)" title="Agent Assign" small
                                            class="mr-4">delete
                                        </v-icon>

                                    </template>
                                </div>
                            </div>


                        </td>






                    </template>
                </v-data-table>
                <div class="pagination-div theme--light" style="height: 50px">
                    <div flex id="row-selector">
                        <div id="page-control">
                            <span>{{ (currentPage - 1) * perPage + 1 }}-{{ endPage }} of
                                {{ totalRows }}</span>
                            <span class="action-icon">
                                <v-icon medium class="move-page" @click="moveNextPage(false)">chevron_left</v-icon>
                                <v-icon medium class="move-page" @click="moveNextPage(true)">chevron_right</v-icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <v-snackbar v-model="snackbar.show" :bottom="true" :right="true" :timeout="snackbar.timeout">
                {{ snackbar.text }}
                <v-btn color="pink" flat @click="snackbar.show = false">Close</v-btn>
            </v-snackbar>
        </div>



        <v-navigation-drawer fixed disable-resize-watcher right :value="isFilterOpen">
            <v-toolbar small color="secondary" style="color: white">
                <v-toolbar-title>Filter</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon flat color="white" @click="isFilterOpen = false">
                    <i class="fas fa-close"></i>
                </v-btn>
            </v-toolbar>
            <div class="flex-column justify-sb height-100-exclude-toolbar overflow-auto">
                <v-container class="sidenavContainer">
                    <v-autocomplete v-model="namemodel" :items="items_" :loading="isLoading" :search-input.sync="search"
                        hide-no-data hide-selected label="Contact Search" placeholder="search" item-text="name"
                        item-value="value">
                    </v-autocomplete>

                </v-container>
                <v-container row class="sidenavFooter">
                    <v-btn flat @click="reset()">Reset</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="fetchfilterdata()">Filter</v-btn>
                </v-container>
            </div>
        </v-navigation-drawer>

        <v-dialog persistent :value="page.isUploadContact" max-width="500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title>
            <span class="headline">Upload Contact</span>
          </v-card-title>
        </v-toolbar>
        <v-container grid-list-md>
          <p>
            <span style="font-weight: bold">Not sure what to upload? </span>
            Click here to download the sample file. Format:
            <a @click="downloadSample('csv')">CSV</a>,
            <a @click="downloadSample('txt')">Txt(Tab-Delimited)</a>.
             Save the file with .csv /.txt extension and upload the
             file.
            
          </p>
          <div class="file-dummy" @click="$refs.file.click()"
            :style="{ background: uploadContact.color + '66', 'border-color': uploadContact.color, color: uploadContact.color, }">
            {{ uploadContact.label }}
          </div>
          <input type="file" id="file" ref="file" accept=".csv" v-on:change="handleFileUpload()" />
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="light" flat @click="CloseUploadContact(false)">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        

      <v-dialog v-model="delete_popup" max-width="400px">
            <v-form ref="refassign">
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>Delete Contact</v-toolbar-title>
                    </v-toolbar>
                    <v-container id="scroll-target" style="max-height: 350px" class="scroll-y">
                        Do you delete this Contact?
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="light" flat @click="deleteCancelpopup()">Cancel</v-btn>
                        <v-btn color="primary" @click="deleteContact()">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-container fluid grid-list-xl page style="padding-top: 10px">
            <inserforms v-if="insert_form" :page_="true" :model="`CONTACT`" @customform="customform_insert($event)">
            </inserforms>
        </v-container>
    </div>
</template>
 
<script>
import { mapGetters } from "vuex";
import api from "@/utils/axios-util";
import inserforms from "./InsertAsterLead.vue";
function getDefaultData() {
  return {
    label: "Please select some files",
    color: "#2196f3",
  };
}
export default {
    components: { inserforms },
    data() {
        return {
            descriptionLimit: 60,
            entries: [],
            isLoading: false,
            namemodel: "",
            items_: [],
            search: null,
            page: {
                title: "Contacts",
                icon: "fa-address-card fa-2x",
                canedit: true,
                isUploadContact:false,
                userassign: false,
                addnew:[{ key: "upload", label: "Upload" }]
            },
            headers: [],
            ids: [],
            ContactData: [],
            perPage: 8,
            currentPage: 1,
            totalRows: 0,
            endPage: 0,
            options: {
                filter: true,
                plus: true,
                editicon: false,
                uploadicon: false,
                downloadicon: false,
                selectedcurrent: "",
                refresh: true
            },
            CloneContact: [],
            export_popup: false,
            exportType: ["CSV", "Txt(Tab-Delimited)"],
            insert_form: false,
            downloadData: [],
            user_email: JSON.parse(localStorage.apiInfo).user_email,
            snackbar: {
                show: false,
                timeout: 6000,
                text: "",
            },
            isFilterOpen: false,
            dynamicFields: [],
            fielddata: [],
            delete_popup: false,
            isfilterval: false,
            delete_id: "",
            uploadContact: {},
        };

    },
    watch: {
        search(val) {

            const payload = {
                value: val,
                skip: 0,
                take: 10,
            };
            this.items_ = []
            this.$store
                .dispatch("GetAsterContacts", payload)
                .then(res => {
                    console.log(res.data)

                    for (let i = 0; i < res.data.length; i++) {
                        let obj = {
                            name: res.data[i].name,
                            value: res.data[i].phone_number
                        }

                        this.items_.push(obj)
                    }

                })
                .catch(err => {
                    console.log(err)
                })

        },
    },
    computed: {
        ...mapGetters(["form"]),
        dateRangeText() {
            return this.dates.join(' ~ ')
        },

    },
    methods: {
        NewContact(){
            this.page.isUploadContact = true;
                 },
        deleteCancelpopup() {
            let scope = this
            scope.delete_popup = false
            scope.delete_id = ""
        },
        refreshThisPage: function () {
            this.reset()

        },
        CloseUploadContact: function () {
      this.page.isUploadContact = false;
      
      this.uploadContact = getDefaultData();
    },
        deleteContact() {
            let scope = this
            let query = {
                modified_by: scope.user_email,
                id: scope.delete_id
            }
            scope.$store
                .dispatch("deleteAsterContact", query)
                .then((response) => {
                    if (response.status === 200) {
                        scope.showSnackBar("Contact Deleted Successfully!");
                        scope.supportdata(scope.currentsupport);
                        scope.delete_popup = false
                        scope.delete_id = ""
                    } else if (response.status === 204) {
                        scope.delete_popup = false
                        scope.delete_id = ""
                        scope.showSnackBar("Contact Unable To Deleted!");
                    } else {
                        scope.delete_popup = false
                        scope.delete_id = ""
                        scope.showSnackBar("Contact Delete failed!");
                    }

                })
                .catch(function () {
                    scope.showSnackBar("Contact Delete failed!");
                });
        },
        deletepopup(data) {
            let scope = this

            scope.delete_id = scope.ids[data]
            scope.delete_popup = true
        },
        moveNextPage(next) {
            const scope = this;
            if (next && scope.totalRows >= scope.currentPage * scope.perPage + 1) {
                scope.currentPage = scope.currentPage + 1;
                scope.supportdata(scope.currentsupport);
            } else if (!next && scope.currentPage !== 1) {
                scope.currentPage = scope.currentPage - 1;
                scope.supportdata(scope.currentsupport);
            }
        },
        fetchfilterdata() {
            let scope = this
            scope.isfilterval = true
            scope.isFilterOpen = false;
            scope.currentPage = 1
            scope.fetchFilter()
        },
        fetchFilter() {

            let scope = this
            const payload = {
                value: this.namemodel,
                skip: this.perPage * (this.currentPage - 1),
                take: this.perPage,
            };
            console.log(payload,"yyyyyyyyyyyyyyyyy777777777777");
            this.$store
                .dispatch("GetAsterContacts", payload)
                .then((response) => {
                    let datas = response.data;
                    scope.CloneContact = [...datas];

                    let temparr = [];
                    datas.forEach((element) => {

                        let tempobj = {};
                        scope.headers.forEach((elm) => {

                            if (
                                element[elm.value] === undefined &&
                                elm.value !== "actions"
                            ) {
                                tempobj[elm.value] = "";
                            }
                            if (
                                elm.value !== "actions" &&
                                element[elm.value] !== undefined
                            ) {
                                if (elm.value == "assgin") {
                                    elm.value = "user";
                                }

                                tempobj[elm.value] = element[elm.value];
                            }

                        });
                        tempobj.action = true;
                        temparr.push(tempobj);
                    });


                    scope.ContactData = temparr;


                    if (response.count !== undefined) {
                        scope.totalRows = response.count;
                    } else {
                        scope.totalRows = 0;
                    }
                    scope.endPage = scope.currentPage * scope.perPage;
                    scope.endPage =
                        scope.endPage < scope.totalRows
                            ? scope.endPage
                            : scope.totalRows;


                })
                .catch(function (err) {

                    scope.showSnackBar(err);
                });
        },
        reset() {
            let scope = this;
            scope.isFilterOpen = false;
            scope.isfilterval = false
            scope.currentPage = 1
            this.namemodel = ""
            this.supportdata()
        },
        isFilter() {
            let scope = this;
            scope.isFilterOpen = true;
        },
        downloadSample(type) {
            const scope = this;
            let ContactFields = "";
            scope.$store.dispatch("GetAsterContactsFields").then((response) => {
             var datas = response.fields;
                ContactFields = datas;
                const header = [];
                for (let i = 0; ContactFields.length > i; ++i) {
                    let key = {
                        key: ContactFields[i].model,
                        label: ContactFields[i].label,
                    };
                    if(ContactFields[i].model !== "id"&& 
                      ContactFields[i].model !=="deleted"&&
                      ContactFields[i].model !=="created_at"&&
                      ContactFields[i].model !=="created_by"&&
                      ContactFields[i].model !=="modified_at"&&
                      ContactFields[i].model !=="modified_by"
                    )
                    {
                        header.push(ContactFields[i].model);
                        
                    }
                    
                    
                    scope.fielddata.push(key);
                }
                let csvContent = "";
                if (type === "csv") {
                    csvContent += "data:text/csv;charset=utf-8,\uFEFF";
                    csvContent += header.join(",");
                } else {
                    csvContent += "data:text/txt;charset=utf-8,\uFEFF";
                    csvContent += header.join("\t");
                }
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "samplefile" + "." + type);
                document.body.appendChild(link);
                link.click();
            });
        },
    
    handleFileUpload: function () {
      var scope = this;
      scope.file = scope.$refs.file.files[0];
      scope.uploadContact.color = "#A64452";
      scope.uploadContact.label = "Uploading";
      let formData = new FormData();
      formData.append("file", scope.file);
      formData.append("created_by", JSON.parse(localStorage.apiInfo).user_email);
      formData.append("modified_by", JSON.parse(localStorage.apiInfo).user_email);
      api.defaults.headers["Content-Type"] = "multipart/form-data";
      api
        .post("/contact/bulkupload", formData)
        .then((response) => {
          api.defaults.headers["Content-Type"] = "application/json";
          scope.uploadContact.color = "#4BB543";
          scope.uploadContact.label = "Uploaded Successfully";
          scope.$refs.file.value = "";
          return response;
        })
        .catch((error) => {
            api.defaults.headers["Content-Type"] = "application/json";
          scope.uploadContact.color = "#F51B00";
          scope.uploadContact.label = "Upload Error";
          return error;
        });
    },
        contact_info(val) {

            let userdata = this.CloneContact.find(
                (elm) => elm.phone_number == val.phone_number
            );

            localStorage.setItem("ticket_templet", JSON.stringify(userdata));

            this.$router.push({
                name: "crm/contactDetail",
            });
        },
        addcontact() {
            let scope = this;
            scope.insert_form = true;
            scope.ContactData = []
            scope.headers = []
        },
        showSnackBar(message) {
            let scope = this;
            scope.snackbar.text = message;
            scope.snackbar.show = true;
            setTimeout(() => {
                scope.snackbar.text = "";
            }, scope.snackbar.timeout);
        },

        customform_insert(val) {
            if (val === 201) {
                this.insert_form = false;
                this.supportdata();
                this.showSnackBar("Contact Succesfully Created");
            } else if (val === false) {
                this.insert_form = false;
                this.supportdata();
            }
        },

        supportdata() {
            let scope = this

            if (scope.isfilterval == true) {
                scope.fetchFilter()
            } else {


                this.$store
                    .dispatch("GetAsterContactsFields")
                    .then((response) => {

                        var datas = response.fields;

                        let AsterContactDetails = datas;
                        datas.map((elm) => elm.model);

                        let dynamicFields = [];
                        scope.headers = []


                        for (let i = 0; i < AsterContactDetails.length; i++) {

                            if (AsterContactDetails[i].show_on_view === true) {
                                if (
                                    AsterContactDetails[i].model === "name" ||
                                    AsterContactDetails[i].model === "phone_number" ||
                                    AsterContactDetails[i].model === "alternative_number"

                                ) {
                                    let key = {
                                        text: AsterContactDetails[i].label,
                                        value: AsterContactDetails[i].model,
                                        align: "center",
                                        sortable: false,
                                    };
                                    // scope.headers.push(key);

                                    if (AsterContactDetails[i].model === "name") {
                                        scope.headers.splice(0, 0, key);
                                    } else if (AsterContactDetails[i].model === "phone_number") {
                                        scope.headers.splice(1, 0, key);
                                    } else if (AsterContactDetails[i].model === "alternative_number") {
                                        scope.headers.splice(2, 0, key);
                                    }




                                }
                            }

                        }
                        scope.dynamicFields = dynamicFields



                        const payload = {

                            skip: scope.perPage * (scope.currentPage - 1),
                            take: scope.perPage,
                            // skip: 0,
                            // take: 10,
                        };

                        scope.$store
                            .dispatch("GetAsterContacts", payload)
                            .then((response) => {
                                let datas = response.data;
                                scope.CloneContact = [...datas];

                                let temparr = [];
                                datas.forEach((element) => {

                                    let tempobj = {};
                                    // scope.ids.push(element.id);
                                    // main
                                    scope.headers.forEach((elm) => {

                                        if (
                                            element[elm.value] === undefined &&
                                            elm.value !== "actions"
                                        ) {
                                            tempobj[elm.value] = "";
                                        }
                                        if (
                                            elm.value !== "actions" &&
                                            element[elm.value] !== undefined
                                        ) {
                                            if (elm.value == "assgin") {
                                                elm.value = "user";
                                            }

                                            tempobj[elm.value] = element[elm.value];
                                        }

                                    });
                                    scope.ids.push(element.id);
                                    tempobj.action = true;
                                    temparr.push(tempobj);
                                });


                                scope.ContactData = temparr;


                                if (response.count !== undefined) {
                                    scope.totalRows = response.count;
                                } else {
                                    scope.totalRows = 0;
                                }
                                scope.endPage = scope.currentPage * scope.perPage;
                                scope.endPage =
                                    scope.endPage < scope.totalRows
                                        ? scope.endPage
                                        : scope.totalRows;


                            })
                            .catch(function (err) {
                                console.log(err, "error1error1");
                                scope.showSnackBar("error1");
                            });

                    })
                    .catch(function () {
                        scope.showSnackBar("error");
                    });
            }
        }
    },
    mounted() {
        this.supportdata()
        this.uploadContact = getDefaultData();

    }


};
</script>
<style>
.tab_view {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    padding: 10px 15px 10px 20px;
}

.tab_button {
    background-color: #cacaca;
    text-align: center;
    display: flex;
    flex-direction: row;
    width: 11%;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    border-radius: 8px;
    border: 1px solid #cacaca;
}

.tab_icon {
    width: 20%;
    text-align: right;
}

.tab_txt {
    width: 80%;
    text-align: center;
    padding-right: 15px;
}

.main_view_ticket {
    display: flex;
    flex-direction: column;
}

.ticket_body_view {
    padding: 10px 20px 10px 20px;
}

.tab_button_swap {
    background-color: rgb(33, 150, 243);
    color: #fafafa;
    text-align: center;
    display: flex;
    flex-direction: row;
    width: 11%;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    border-radius: 8px;
    border: 1px solid #cacaca;
}

.icon_section {
    align-content: center;
    padding: 0px 0px 0px 33px;
}

.exportflex {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 20px;
}

.export {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 40%;
    height: 130px;
    text-align: center;
    padding: 20px;
    background-color: #cacaca;
    color: #ffffff;
    border-radius: 10px;
}

.hovericon {
    color: #2c3e50;
    cursor: pointer;
}

.asdff {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
}
.file-dummy {
  width: 100%;
  padding: 30px;
  border: 2px dashed;
  text-align: center;
  transition: #2196f333 0.3s ease-in-out;
  cursor: pointer;
  font-weight: bold;
}
</style>
